import React from 'react';

export interface LocationMapEmbedProps {
  /** Full address query for Google Maps embed/search. */
  query: string;
  height?: number;
  className?: string;
}

function buildMapsSearchUrl(query: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

/**
 * Embeds Google Maps when REACT_APP_GOOGLE_MAPS_API_KEY is configured;
 * otherwise shows a link-only fallback (same as logged-in detail before CR-013).
 */
const LocationMapEmbed: React.FC<LocationMapEmbedProps> = ({
  query,
  height = 300,
  className = 'mb-3',
}) => {
  const trimmed = query.trim();
  if (!trimmed) return null;

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY?.trim();
  const searchUrl = buildMapsSearchUrl(trimmed);

  if (!apiKey) {
    return (
      <div className={`d-grid ${className}`}>
        <a
          href={searchUrl}
          className="btn btn-outline-primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fas fa-directions me-2" />
          Google Maps&apos;te Yol Tarifi Al
        </a>
      </div>
    );
  }

  return (
    <>
      <div className={`map-container ${className}`}>
        <iframe
          title="İlan Konumu"
          width="100%"
          height={height}
          style={{ border: 0, borderRadius: '8px' }}
          src={`https://www.google.com/maps/embed/v1/place?key=${encodeURIComponent(apiKey)}&q=${encodeURIComponent(trimmed)}&zoom=12`}
          allowFullScreen
        />
      </div>
      <div className="d-grid">
        <a
          href={searchUrl}
          className="btn btn-outline-primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fas fa-directions me-2" />
          Google Maps&apos;te Yol Tarifi Al
        </a>
      </div>
    </>
  );
};

export default LocationMapEmbed;
